"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RateLimitInfo = /** @class */ (function () {
    function RateLimitInfo(isActive, maxPoints, recoveryTime, pointsAtAccountCreation) {
        this.isActive = isActive;
        this.maxPoints = maxPoints;
        this.recoveryTime = recoveryTime;
        this.pointsAtAccountCreation = pointsAtAccountCreation;
    }
    return RateLimitInfo;
}());
exports.default = RateLimitInfo;
//# sourceMappingURL=rate-limit-info.js.map